import { FC, useCallback } from "react";
import { useModal } from "../../../core";
import { CloseModalIcon } from "../../../core/modules/CloseIconNew";
import { Project } from "@brg/api";
import { useTranslation } from "react-i18next";
import { RectangularButtonFilled, RectangularButtonHollow } from "../../components/buttons";
import {
    TransferModalBodyStep1,
    CloseModalIconWrapper,
    TransferModalHeaderRow,
    TransferModalTitleBreadcrumb,
    TransferModalTitleMain,
    TransferModalDescription,
    TransferModalButtonsRowStep1,
} from "./styles";
import { BrgButton, ButtonVariant } from "@brg/ui";

export interface TransferProjectStep1ModalProps {
    projectId?: string;
    project?: Project;
}

export const TransferProjectStep1Modal: FC<TransferProjectStep1ModalProps> = ({ projectId, project }) => {
    const modal = useModal();
    const { t } = useTranslation();

    const onBack = useCallback(() => {
        modal.back();
    }, [modal]);

    const onTransfer = useCallback(() => {
        modal.show("transfer-project-link", { projectId, project });
    }, [modal, projectId, project]);

    const onClose = useCallback(() => {
        modal.hide();
    }, [modal]);

    return (
        <TransferModalBodyStep1>
            <TransferModalHeaderRow>
                <div>
                    <TransferModalTitleMain>{t("transfer_project_modal.title")}</TransferModalTitleMain>
                </div>
                <CloseModalIconWrapper>
                    <CloseModalIcon onClick={onClose} width={22} height={22} />
                </CloseModalIconWrapper>
            </TransferModalHeaderRow>
            <TransferModalDescription>
                {t("transfer_project_modal.description")}
            </TransferModalDescription>
            <TransferModalButtonsRowStep1>
                <BrgButton variant={ButtonVariant.Hollow} fullWidth onClick={onBack}>{t("transfer_project_modal.back")}</BrgButton>
                <BrgButton variant={ButtonVariant.Filled} fullWidth onClick={onTransfer}>
                    {t("transfer_project_modal.transfer_btn")}
                </BrgButton>
            </TransferModalButtonsRowStep1>
        </TransferModalBodyStep1>
    );
};
import { FC, useCallback } from "react";
import { useModal } from "../../../core";
import { CloseModalIcon } from "../../../core/modules/CloseIconNew";
import { Project } from "@brg/api";
import { useTranslation } from "react-i18next";
import { RectangularButtonFilled, RectangularButtonHollow } from "../../components/buttons";
import {
    TransferModalBodyStep1,
    CloseModalIconWrapper,
    TransferModalHeaderRow,
    TransferModalTitleBreadcrumb,
    TransferModalTitleMain,
    TransferModalDescription,
    TransferModalButtonsRowStep1,
} from "./styles";
import { BrgButton, ButtonVariant } from "@brg/ui";

export interface TransferProjectStep1ModalProps {
    projectId?: string;
    project?: Project;
}

export const TransferProjectStep1Modal: FC<TransferProjectStep1ModalProps> = ({ projectId, project }) => {
    const modal = useModal();
    const { t } = useTranslation();

    const onBack = useCallback(() => {
        modal.back();
    }, [modal]);

    const onTransfer = useCallback(() => {
        modal.show("transfer-project-link", { projectId, project });
    }, [modal, projectId, project]);

    const onClose = useCallback(() => {
        modal.hide();
    }, [modal]);

    return (
        <TransferModalBodyStep1>
            <TransferModalHeaderRow>
                <div>
                    <TransferModalTitleMain>{t("transfer_project_modal.title")}</TransferModalTitleMain>
                </div>
                <CloseModalIconWrapper>
                    <CloseModalIcon onClick={onClose} width={22} height={22} />
                </CloseModalIconWrapper>
            </TransferModalHeaderRow>
            <TransferModalDescription>
                {t("transfer_project_modal.description")}
            </TransferModalDescription>
            <TransferModalButtonsRowStep1>
                <BrgButton variant={ButtonVariant.Hollow} fullWidth onClick={onBack}>{t("transfer_project_modal.back")}</BrgButton>
                <BrgButton variant={ButtonVariant.Filled} fullWidth onClick={onTransfer}>
                    {t("transfer_project_modal.transfer_btn")}
                </BrgButton>
            </TransferModalButtonsRowStep1>
        </TransferModalBodyStep1>
    );
};
